import { FC } from 'react';
import { EditButton } from './editButton';
import { ContentHead } from '../../pages/head';
import { ActionArea, ActionAreaProps } from '../../pages/head/actionArea';
import { Mode } from '..';
import { useTranslation } from 'react-i18next';
import { EditIcon, SaveIcon } from '../../../../icons';
import { Button } from '../../../atomic/button';

type Props = {
  title?: string;
  subtitle?: string;
  startComponent?: JSX.Element;
  canEdit: boolean;
  canSubmit: boolean;
  changeMode: () => void;
  mode: Mode;
  onCancel?: () => void;
  onSubmit?: () => void;
  actionAreaProps?: ActionAreaProps;
};

export const DataViewEditBoxHead: FC<Props> = ({
  title,
  subtitle,
  startComponent,
  canEdit,
  canSubmit,
  changeMode,
  mode,
  onCancel: onCancel,
  onSubmit,
  actionAreaProps
}) => {
  if (!title && !canEdit) {
    return <></>;
  }

  const { t } = useTranslation('common');

  const cancel = () => {
    onCancel && onCancel();
    changeMode();
  };

  const submit = () => {
    if (canSubmit) {
      onSubmit && onSubmit();
      changeMode();
    }
  };

  const renderButtons = () => {
    if (canEdit == false) return <></>;
    if (mode == 'edit')
      return (
        <>
          <Button variant="secondary" onClick={cancel}>
            {t('CANCEL')}
          </Button>
          <Button onClick={submit} disabled={!canSubmit}>
            <SaveIcon />
            {t('SAVE')}
          </Button>
        </>
      );
    if (!actionAreaProps?.threePointMenuConfig) {
      return <EditButton onClick={changeMode} />;
    }
    return <></>;
  };

  const renderOperations = () => {
    if (actionAreaProps?.operations) {
      return (
        <>
          {actionAreaProps.operations}
          {renderButtons()}
        </>
      );
    }

    return renderButtons();
  };

  const renderThreePontMenu = () => {
    if (
      actionAreaProps?.threePointMenuConfig &&
      actionAreaProps?.threePointMenuConfig?.length > 0
    ) {
      return mode === 'edit'
        ? actionAreaProps.threePointMenuConfig
        : [
            {
              label: t('EDIT'),
              icon: <EditIcon />,
              onClick: changeMode
            },
            ...actionAreaProps.threePointMenuConfig
          ];
    }
  };

  return (
    <ContentHead
      headline={title}
      subtitle={subtitle}
      renderBeforeHeadline={() => (startComponent ? startComponent : <></>)}
      renderActions={() => (
        <ActionArea
          threePointMenuConfig={renderThreePontMenu()}
          buttonConfig={actionAreaProps?.buttonConfig}
          operations={renderOperations()}
        />
      )}
      showActions={true}
    />
  );
};
